var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyLogo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 172,
    height: 58,
    viewBox: "0 0 172 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_209",
    "data-name": "\\uC0AC\\uAC01\\uD615 209",
    width: 172,
    height: 58,
    transform: "translate(0.383 0.023)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0.38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "company_logo01",
    transform: "translate(-0.383 -0.023)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company_logo1",
    transform: "translate(10.778 6.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3",
    "data-name": "\\uD328\\uC2A4 3",
    d: "M236.289,295.575v2.044h-17.1v-2.044h7.384V291.82h-6.008V281.182h2.274v2.733h9.782v-2.733h2.293V291.82h-6.028v3.754Zm-3.671-9.658h-9.782v3.9h9.782Z",
    transform: "translate(-161.208 -266.371)",
    fill: "#474645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_4",
    "data-name": "\\uD328\\uC2A4 4",
    d: "M252.928,290.436h-2.315V282.76h-6.821v-2.065h9.136Zm-7.9,7.947v-6.8h2.316v4.755h12.931v2.045Zm12.556-18.23h2.316v11.91h-2.316v-5.444h-3.045V284.6h3.045Z",
    transform: "translate(-166.871 -266.134)",
    fill: "#474645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_5",
    "data-name": "\\uD328\\uC2A4 5",
    d: "M285.737,289.357v1.982h-17.1v-1.982h7.383v-1.627H270.01v-7.28h2.274v1.731h9.783v-1.731h2.293v7.28h-6.028v1.627Zm-1.377,3.5v6.006h-2.315v-4.045H269.572v-1.961Zm-2.293-8.76h-9.783v1.69h9.783Z",
    transform: "translate(-172.589 -266.203)",
    fill: "#474645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6",
    "data-name": "\\uD328\\uC2A4 6",
    d: "M293.718,283.344V281.3h11.1v2.044h-4.672l5.172,12.16-2.044.876-3.963-9.511-3.942,9.658-2.086-.876,5.193-12.307Zm13.808-3.191h2.316v18.605h-2.316Z",
    transform: "translate(-178.262 -266.134)",
    fill: "#474645"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_7",
    "data-name": "\\uD328\\uC2A4 7",
    d: "M318.356,291.994h17.1v2.044h-7.4v4.8h-2.316v-4.8h-7.383Zm3.651-9.094h9.782v-2.358h2.294v8.949H319.732v-8.949h2.275Zm9.782,2h-9.782v2.566h9.782Z",
    transform: "translate(-184.033 -266.224)",
    fill: "#474645"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_15",
    "data-name": "\\uADF8\\uB8F9 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8",
    "data-name": "\\uD328\\uC2A4 8",
    d: "M178.752,283.5a8.145,8.145,0,0,0-11.586,2.432,8.153,8.153,0,0,1-14.738-2.242h0c-.008-.03-.014-.055-.022-.085s-.019-.068-.027-.1a10.443,10.443,0,0,1-.416-3.238c0-7.307,7.494-15.441,18.292-15.441,11.056,0,17.381,8.417,19.012,13.094-.028-.082-.054-.164-.082-.249a23.284,23.284,0,0,0-45.307,7.553c0,11.492,8.29,21.33,19.787,21.33a18.7,18.7,0,0,0,18.16-12.228,8.972,8.972,0,0,0-3.068-10.823",
    transform: "translate(-143.873 -261.943)",
    fill: "#002a56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_9",
    "data-name": "\\uD328\\uC2A4 9",
    d: "M191.824,279.234a20.523,20.523,0,0,0-19.156-13.548c-10.8,0-18.292,8.133-18.292,15.44a10.47,10.47,0,0,0,.416,3.239,6.874,6.874,0,0,1-.214-1.661c0-7.608,7.619-12.881,15.449-12.881a19.2,19.2,0,0,1,19.2,19.194,21.16,21.16,0,0,1-11.731,18.958l0,.005a23.288,23.288,0,0,0,15.354-21.9,22.982,22.982,0,0,0-1.025-6.85",
    transform: "translate(-146.29 -262.805)",
    fill: "#dc0021"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyLogo01);
export default __webpack_public_path__ + "static/media/company_logo01.39aad45a806f5999618b17de4756a4cf.svg";
export { ForwardRef as ReactComponent };